
<template>
  <div class="client-addresses-list">
    <h1 class="window-title">
      Адреса клиента:
    </h1>
    <v-loader v-if="isLoading"/>

    <template v-else>
      <staggering-list-transitions no-leave-delay>
        <v-address

          v-for="(item, i) in addressItems"
          :key="item.id"
          :item="item"
          :checked="item.id === currentAddressId"
          :data-index="i"
          @onDelete="confirmDeleteAddress"
        />
      </staggering-list-transitions>

      <template v-if="false">
        <!--!addressItems.length-->
        <span class="d-block display-3 text-center">Нет адресов</span>
      </template>
    </template>
    <delete-confirm-dialog
      v-model="showDeleteAddressConfirm"
      :loading="deleting"
      @confirm="deleteAddress"
    >
      Вы действительно хотите удалить адрес?<br>
      <span class="deleting-address-name">{{ deletedAddressName }}</span>
    </delete-confirm-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import _ from 'lodash'
  import StaggeringListTransitions from '@/components/ui/transitions/StaggeringListTransitions.vue'
  import VAddress from '@/components/order-processing/order-components/second-step/Address.vue'
  import snackbarMessage from '@/mixins/snackbar-message'
  import orderEdit from '@/mixins/order-edit'
  import VLoader from '@/components/loader/Loader.vue'
  import ClientAddressDataService from '@/services/api/ClientAddressDataService'
  import DeleteConfirmDialog from '@/components/ui/dialogs/DeleteConfirmDialog.vue'

  export default {
    name: 'ClientAddressesList',
    components: {
      DeleteConfirmDialog,
      VLoader,
      VAddress,
      StaggeringListTransitions,
    },
    mixins: [
      snackbarMessage,
      orderEdit,
    ],
    props: {
      clientId: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        isLoading: false,
        addressToDelete: null,
        showDeleteAddressConfirm: false,
        deleting: false,
      }
    },
    computed: {
      ...mapGetters({
        addressItems: 'clients/getClientsAddress',
      }),
      deletedAddressName () {
        return this.addressToDelete?.fullAddress
      },
      currentAddressId () {
        return this.basket?.clientAddress?.id
      },
    },

    methods: {
      async loadAddresses () {
        this.isLoading = true
        try {
          const payload = {
            clientId: this.clientId,
            limit: 100000,
          }
          await this.$store.dispatch('clients/fetchClientsAddressList', payload)
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.isLoading = false
      },
      confirmDeleteAddress (address) {
        this.addressToDelete = address
        this.showDeleteAddressConfirm = true
      },
      async deleteAddress () {
        if (this.addressToDelete) {
          this.deleting = true
          console.log('delete', this.addressToDelete)
          try {
            await ClientAddressDataService.delete(this.addressToDelete.id)
            _.remove(this.addressItems, (address) => {
              return address.id === this.addressToDelete.id
            })
            this.addressToDelete = null
            this.showDeleteAddressConfirm = false
          } catch (e) {
            this.showErrorFromResponse(e)
          }

          this.deleting = false
        }
      },
    },

    created () {
      if (_.isEmpty(this.addressItems) && this.clientId) {
        this.loadAddresses()
      }
    },
  }
</script>

<style scoped lang="less">

</style>
